'use client';

import { NavigationCarousel } from '@/features/carousel';
import { EasyAccess } from '@/features/tag';
import BrandCategoriesCombinationListSkeleton from './brand-categories-combination-list-skeleton';
import { useGetBrandCombinationsList } from '../_utils/use-get-brand-combinations-list';
interface Props {
  brand_id: string;
}
function BrandCategoriesCombinationList({
  brand_id
}: Props) {
  const {
    data,
    isLoading
  } = useGetBrandCombinationsList({
    brand_id
  });
  if (isLoading) return <BrandCategoriesCombinationListSkeleton />;
  if (!data || data.length === 0) return null;
  return <div data-test='brand-categories-combination-list' className='homepage-container relative mt-4 overflow-hidden lg:mt-6' data-sentry-component="BrandCategoriesCombinationList" data-sentry-source-file="brand-categories-combination-list.tsx">
            <NavigationCarousel options={{
      perView: 'auto',
      mode: 'snap',
      spacing: 4
    }} skeleton={<BrandCategoriesCombinationListSkeleton />} data-sentry-element="NavigationCarousel" data-sentry-source-file="brand-categories-combination-list.tsx">
                {data.map(({
        title,
        slug
      }) => {
        return <EasyAccess sendEvents={false} key={slug} href={`/brand-categories/${slug}`} size='medium' className='keen-slider__slide min-w-fit max-w-fit'>
                            {title}
                        </EasyAccess>;
      })}
            </NavigationCarousel>
        </div>;
}
export default BrandCategoriesCombinationList;